import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import brandConfig from "./brand.json";

export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "c5702f8e-e6a8-4a89-a5aa-7d8f113b1748",
  title: "Movetix Tickets",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "ms-MY",
  currency: "MYR",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: [
    "apple-touch-icon-180x180.png",
    "favicon-16x16.png",
    "favicon-32x32.png",
    "favicon.ico",
  ],
  logo: "/assets/images/logo.png",
  domain: "movetix.airasia.com",
  detectLocale: true,
  detectCurrency: true,
};
